export { default as useGetEmptyDashboardLinks } from "./GetEmptyDashboardLinks";
